"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useCollapse", {
  enumerable: true,
  get: function get() {
    return _useCollapse.default;
  }
});
exports.default = void 0;

var _Collapse = _interopRequireDefault(require("./Collapse"));

var _useCollapse = _interopRequireDefault(require("./useCollapse"));

var _default = _Collapse.default;
exports.default = _default;
//# sourceMappingURL=index.js.map